import {
  Col,
  Row,
  MenuProps,
  TabsProps,
  Tabs,
  Space,
  Tag,
  Dropdown,
} from 'antd';
import { MainLayout } from 'components';
import { useEffect, useState } from 'react';
import { CategoryCancel, DownloadIcon, EditInfo, MoreOption } from 'assets/svg';
import { Content } from 'antd/es/layout/layout';
import { category, tag, status, supplier } from 'assets/images';
import Button from 'components/Button';
import pageTitleStore from 'store/pageTitleStore';
import moment from 'moment';
import PreOrderProduct from 'components/Modules/Cart/PreOrder/PreOrderDetailTabs/PreOrderProduct';
import PreOrderInfo from 'components/Modules/Cart/PreOrder/PreOrderDetailTabs/PreOrderInfo';
import { ShoppingCartOutlined } from '@ant-design/icons';
import PreOrderStoreRegisted from 'components/Modules/Cart/PreOrder/PreOrderDetailTabs/PreOrderStoreRegisted';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import CartApi from 'apis/CartApi';

export default function EditCartPage(): JSX.Element {
  const params = useParams<any>();
  const { plantId, cartRegisterId } = params;

  const { isLoading: getCartByPlantIdAndCartIdLoading } = useQuery(
    ['getCartRegister', plantId, cartRegisterId],
    () => {
      CartApi.getCartByPlantIdAndCartId(plantId, cartRegisterId)
        .then((res) => {
          setCart(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  );

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);

  const [product, setProduct] = useState<any>();
  const [cart, setCart] = useState<any>();

  useEffect(() => {
    const pageTitle = 'PNJ - PMS';
    document.title = pageTitle;
    setTitle(`${cart?.cart_name}`);
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="/preorder">Giỏ hàng</a>{' '}
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/preorder">Đăng ký mẫu</a>
          </p>
        ),
      },
      { title: <a href="">{cart?.cart_name}</a> },
    ]);
  }, [cart]);

  const menuItems: MenuProps = {
    items: [
      {
        label: 'Chỉnh sửa giỏ hàng',
        key: '4',
        icon: <EditInfo />,
      },
      {
        label: 'Tải file Excel',
        key: '5',
        icon: <DownloadIcon />,
      },
      {
        label: <div className="text-red-600">Xoá giỏ hàng</div>,
        key: '6',
        icon: <CategoryCancel />,
      },
    ],
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: `Mẫu đăng ký`,
      children: <PreOrderProduct cart={cart} />,
    },
    {
      key: '2',
      label: `Thông tin`,
      children: <PreOrderInfo cart={cart} />,
    },
    {
      key: '3',
      label: `Cửa hàng đăng ký`,
      children: <PreOrderStoreRegisted cart={cart} />,
    },
    {
      key: '4',
      label: `Đơn hàng`,
      // children: `Content of Tab Pane 2`,
    },
    {
      key: '5',
      label: `Lịch sử phê duyệt`,
      // children: `Content of Tab Pane 3`,
    },
  ];

  return (
    <MainLayout isLoading={getCartByPlantIdAndCartIdLoading}>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1"
      >
        <Col span={12} className="flex justify-end">
          <Space>
            <Button customClass="items-center">
              <ShoppingCartOutlined />
              Đặt hàng
            </Button>
          </Space>
        </Col>
      </Row>
      <Content className="my-2">
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          align={'middle'}
          justify={'start'}
          style={{ marginBottom: '10px' }}
        >
          <Col span={22} className="flex items-center">
            <Tag color="#00538F" className="custom-tag">
              <span className="text-base font-bold">Mới tạo</span>
            </Tag>

            <strong style={{ fontSize: '28px' }}>{cart?.cart_name}</strong>
          </Col>
          <Col span={2} className="flex justify-end">
            <Dropdown
              menu={menuItems}
              trigger={['click']}
              placement="bottomRight"
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  <MoreOption />
                </Space>
              </a>
            </Dropdown>
          </Col>
        </Row>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col flex="auto">
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                <div className="text-base font-bold text-neutral-80 flex gap-2">
                  <img src={category} />
                  <div>Mã giỏ hàng</div>
                </div>
                <div className="text-base font-semibold text-neutral-30 ml-8">
                  {cart?.cart_code}
                </div>
              </Col>
              <Col className="" span={6}>
                <div className="text-base font-bold text-neutral-80 flex gap-2">
                  <img src={supplier} />
                  <div>Loại giỏ hàng</div>
                </div>
                <div className="text-base font-semibold text-neutral-30 ml-8 ">
                  {cart?.cart_type_name}
                </div>
              </Col>
              <Col className="" span={6}>
                <div className="text-base font-bold text-neutral-80 flex gap-1">
                  <img src={status} />
                  <div>Ngày phát sinh</div>
                </div>
                <div className="text-base font-semibold text-neutral-30 ml-8">
                  {moment(cart?.release_date).format('DD/MM/YYYY')}
                </div>
              </Col>
              <Col className="" span={6}>
                <div className="text-base font-bold text-neutral-80 flex gap-1">
                  <img src={tag} />
                  <div>Ngày hết hạn</div>
                </div>
                <div className="text-base font-semibold text-neutral-7030 ml-8">
                  {moment(cart?.expiration_date).format('DD/MM/YYYY')}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
      <Content>
        <Tabs defaultActiveKey="1" items={items} />
      </Content>
    </MainLayout>
  );
}
